function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "exitTitle"
}, "exit");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "CA75B0FC-D7E6-4996-B796-363240B5647F");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-529.000000, -270.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings_Button_UI_Exit_Icon",
  transform: "translate(529.000000, 270.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 80,
  height: 80
}), /*#__PURE__*/React.createElement("path", {
  d: "M54,22 L54,58 L26.1818182,58 L26.1818182,49.34816 L31.0909091,49.34816 L31.0909091,53.0909091 L49.0909091,53.0909091 L49.0909091,26.9090909 L31.0909091,26.9090909 L31.0909091,31.0136564 L26.1818182,31.0136564 L26.1818182,22 L54,22 Z M26.180126,32.6363636 L29.0378028,35.3502039 L25.9325778,38.2976596 L35.1818182,38.2987648 L35.1818182,41.9339839 L25.3209436,41.9332328 L29.0448942,45.4699132 L26.1892552,48.1818182 L18,40.404756 L26.180126,32.6363636 Z",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));

var SvgSettingsButtonUiExitIcon = function SvgSettingsButtonUiExitIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    "aria-labelledby": "exitTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "exitTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsButtonUiExitIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-button-ui-exit-icon.bf1ced21.svg";
export { ForwardRef as ReactComponent };